/**
 * Default entities provided by atom-module.
 * These are the core entities available in every project.
 */
export enum DefaultEntities {
  /** Global entity - root context with no identifier */
  Global = "Global",
  /** User entity - authenticated user context */
  User = "User",
}
